/** Bar-chart config, grouped so members are accessed as `BarChartConstants.x` (no clash with the multi-series `maxBarThickness`). */
export const BarChartConstants = {
  /** Below this share of the longest bar, the value label is drawn outside the bar. */
  insideLabelMinRatio: { vertical: 0.2, horizontal: 0.25 },
  maxBarThickness: { vertical: 72, horizontal: 40 },
  datalabelOffset: { vertical: 2, horizontal: 4 },
} as const;
